/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_balanced = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balanced 30/40/30`)
};

const es_macro_balanced = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equilibrado 30/40/30`)
};

const de_macro_balanced = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewogen 30/40/30`)
};

const nl_macro_balanced = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgebalanceerd 30/40/30`)
};

const fr_macro_balanced = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équilibrée 30/40/30`)
};

const it_macro_balanced = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilanciata 30/40/30`)
};

const pt_br2_macro_balanced = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equilibrada 30/40/30`)
};

const pt_macro_balanced = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equilibrada 30/40/30`)
};

const ja_macro_balanced = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バランス型 30/40/30`)
};

const zh_macro_balanced = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`均衡型 30/40/30`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_balanced = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_balanced(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_balanced", locale)
	if (locale === "en") return en_macro_balanced(inputs)
	if (locale === "es") return es_macro_balanced(inputs)
	if (locale === "de") return de_macro_balanced(inputs)
	if (locale === "nl") return nl_macro_balanced(inputs)
	if (locale === "fr") return fr_macro_balanced(inputs)
	if (locale === "it") return it_macro_balanced(inputs)
	if (locale === "pt-BR") return pt_br2_macro_balanced(inputs)
	if (locale === "pt") return pt_macro_balanced(inputs)
	if (locale === "ja") return ja_macro_balanced(inputs)
	return zh_macro_balanced(inputs)
};